import _extends from "@babel/runtime/helpers/esm/extends";
import { Box, Image, Link } from '@magalu/stereo-ui/atoms';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import withLayoutProps from '../../../hocs/withLayoutProps';
import AdsBannerSkeleton from '../AdsBannerSkeleton';
import { useAdsBanner } from './useAdsBanners';
import Video from './Video';
var AdsBanner = function AdsBanner(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _staticProps$attribut = staticProps.attributeStyle,
    attributeStyle = _staticProps$attribut === void 0 ? {} : _staticProps$attribut,
    _staticProps$aspectRa = staticProps.aspectRatio,
    aspectRatio = _staticProps$aspectRa === void 0 ? 'auto' : _staticProps$aspectRa,
    adsPath = staticProps.adsPath,
    _staticProps$bg = staticProps.bg,
    bg = _staticProps$bg === void 0 ? 'transparent' : _staticProps$bg,
    _staticProps$borderRa = staticProps.borderRadius,
    borderRadius = _staticProps$borderRa === void 0 ? '8px' : _staticProps$borderRa,
    _staticProps$hasPlace = staticProps.hasPlaceholder,
    hasPlaceholder = _staticProps$hasPlace === void 0 ? false : _staticProps$hasPlace,
    height = staticProps.height,
    _staticProps$marginBo = staticProps.marginBottom,
    marginBottom = _staticProps$marginBo === void 0 ? '0px' : _staticProps$marginBo,
    _staticProps$marginTo = staticProps.marginTop,
    marginTop = _staticProps$marginTo === void 0 ? '0px' : _staticProps$marginTo,
    _staticProps$slot = staticProps.slot,
    slot = _staticProps$slot === void 0 ? '' : _staticProps$slot,
    width = staticProps.width;
  var _useAdsBanner = useAdsBanner({
      data: data,
      "static": staticProps,
      structure: structure
    }),
    banner = _useAdsBanner.banner,
    handleClick = _useAdsBanner.handleClick,
    inView = _useAdsBanner.inView,
    isBannerLoading = _useAdsBanner.isBannerLoading,
    isVideo = _useAdsBanner.isVideo,
    ref = _useAdsBanner.ref;
  var bannerRedirectUrl = useMemo(function () {
    if (!(banner == null ? void 0 : banner.redirectUrl)) return null;
    try {
      var url = new URL(banner.redirectUrl);
      url.searchParams.append('track_id', banner.trackId);
      url.searchParams.append('internal_ad', 'true');
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [banner]);
  var shouldShowBanner = (banner == null ? void 0 : banner.redirectUrl) && !isBannerLoading;
  var shouldShowSkeleton = isBannerLoading && hasPlaceholder;
  if (!shouldShowBanner && !shouldShowSkeleton) {
    return null;
  }
  return React.createElement(React.Fragment, null, shouldShowBanner && React.createElement(Box, {
    ref: ref,
    bg: bg,
    marginBottom: marginBottom,
    marginTop: marginTop
  }, React.createElement(Link, {
    "data-testid": "ads-banner",
    href: bannerRedirectUrl,
    style: _extends({
      aspectRatio: aspectRatio,
      display: 'block'
    }, attributeStyle),
    onMouseDown: handleClick
  }, React.createElement("span", {
    "data-testid": "ads-banner_screenshot",
    "ads-screenshot-id": "ads-banner_".concat(slot, "_").concat(banner == null ? void 0 : banner.campaignId)
  }), isVideo ? React.createElement(Video, {
    adsPath: adsPath,
    banner: banner,
    borderRadius: borderRadius,
    inView: inView
  }) : React.createElement(Image, {
    alt: "Banner de ofertas do Magazine Luiza",
    src: banner.imageUrl,
    style: {
      borderRadius: borderRadius,
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      width: '100%'
    }
  }))), shouldShowSkeleton && React.createElement(AdsBannerSkeleton, {
    bg: bg,
    height: height,
    isVisible: true,
    width: width
  }));
};
AdsBanner.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
process.env.NODE_ENV !== "production" ? AdsBanner.propTypes = {
  data: PropTypes.shape({}),
  "static": PropTypes.oneOfType([PropTypes.shape({
    isBannerCarousel: PropTypes.bool,
    position: PropTypes.string,
    slot: PropTypes.string
  }), PropTypes.shape({
    attributeStyle: PropTypes.shape({}),
    campaignId: PropTypes.string,
    customerId: PropTypes.string,
    hasPlaceholder: PropTypes.bool,
    height: PropTypes.string,
    imageUrl: PropTypes.string,
    index: PropTypes.number,
    position: PropTypes.string,
    redirectUrl: PropTypes.string,
    slot: PropTypes.string,
    trackId: PropTypes.string,
    width: PropTypes.string
  })]),
  structure: PropTypes.shape({
    cookies: PropTypes.shape({
      accountData: PropTypes.shape({
        customerId: PropTypes.string
      })
    })
  })
} : void 0;
AdsBanner.ssr = true;
export default withLayoutProps(AdsBanner);